<template>
  <!-- paypal核对 -->
  <div class="opage">
    <div>
      <!-- paypal核对 -->
      <baseBreadcrumb
        page="paypal核对"
        :menu="$t('message.money')"
      ></baseBreadcrumb>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 订单号.派送单号 -->
          <div class="item">
            <!-- 搜索内容 -->
            <el-input
              v-model="searchInput"
              :placeholder="$t('message.searchContent')"
              clearable
            >
            </el-input>
          </div>
          <!-- 开始日期-->
          <div class="item">
            <el-date-picker
              v-model="datas.start_time"
              :placeholder="$t('message.startDate')"
              class="Container"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 240px"
            >
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker
              v-model="datas.end_time"
              :placeholder="$t('message.dateClosed')"
              class="Container"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 240px"
            >
            </el-date-picker>
          </div>

          <!-- 核对 -->
          <el-button type="primary" @click="search"> paypal核对 </el-button>
          <!-- 重置 -->
          <!-- <el-button @click="reset">
              {{ $t("message.reset") }}
            </el-button> -->
        </div>
      </div>
      <div class="body">
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 入金帐户 -->
            <li style="background-color: aqua">入金帐户</li>
            <!-- 入金流水号 -->
            <li class="flex15" style="background-color: aqua">入金流水号</li>
            <!-- paypal入金日期 -->
            <li style="background-color: aqua">paypal入金日期</li>
            <!-- paypal订单/配送单子 -->
            <li style="background-color: aqua">paypal订单/配送单子</li>
            <!-- paypal入金 -->
            <li style="background-color: aqua">paypal入金</li>
            <!-- 平台帐户 -->
            <li style="background-color: yellow">平台帐户</li>
            <!-- 平台入金 -->
            <li style="background-color: yellow">平台入金</li>
            <!-- 平台订单/配送单子 -->
            <li style="background-color: yellow">平台订单/配送单子</li>
            <!-- 平台入金时间 -->
            <li style="background-color: yellow">平台入金时间</li>
            <!-- 平台流水号 -->
            <li class="flex15" style="background-color: yellow">平台流水号</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">
              {{ ((datas.page || 1) - 1) * (datas.pageSize || 10) + index + 1 }}
            </li>
            <!-- 入金帐户 -->
            <li>{{ (item.pay_pal_bill || {}).realname }}</li>
            <!-- 入金流水号 -->
            <li class="flex15">
              {{ (item.pay_pal_bill || {}).serial_number }}
            </li>
            <!-- paypal入金日期 -->
            <li>{{ (item.pay_pal_bill || {}).created_at }}</li>
            <!-- paypal订单/配送单子 -->
            <li>{{ (item.pay_pal_bill || {}).order_sn }}</li>
            <!-- paypal入金 -->
            <li>{{ (item.pay_pal_bill || {}).amount }}</li>
            <!-- 平台帐户 -->
            <li>
              <div style="text-align: center">
                <p>{{ (item.user_bill || {}).user_id }}</p>
                <p>{{ (item.user_bill || {}).realname }}</p>
              </div>
            </li>
            <!-- 平台入金 -->
            <li>{{ (item.user_bill || {}).amount }}JPY</li>
            <!-- 平台订单/配送单子 -->
            <li>{{ (item.user_bill || {}).order_sn }}</li>
            <!-- 平台入金时间 -->
            <li>{{ (item.user_bill || {}).created_at }}</li>
            <!-- 平台流水号 -->
            <li class="flex15">{{ (item.user_bill || {}).serial_number }}</li>
          </ul>
          <!-- 暂无数据 -->
          <div v-if="tableData == false" class="No_data">
            {{ $t("message.noDataYet") }}
          </div>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer" v-if="false">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="datas.page"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentMonthFirst, getCurrentMonthLast } from "@/utlis/date.js";
export default {
  data() {
    return {
      datas: {
        start_time: getCurrentMonthFirst(),
        end_time: getCurrentMonthLast(),
      },
      tableData: [],
      total: 0,
      searchType: "", //搜索类别
      searchInput: "",
    };
  },
  component: {},
  created() {
    // this.datas.start_time = getCurrentMonthFirst();
    // this.datas.end_time = getCurrentMonthLast();
    this.confirmedList();
  },
  methods: {
    // 重置
    reset() {
      this.datas = {};
      this.searchInput = "";
      this.searchType = "";
      this.confirmedList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.confirmedList();
    },
    // 获取列表
    confirmedList() {
      let returnDatas = JSON.parse(JSON.stringify(this.datas));
      returnDatas.keywords = this.searchInput;
      this.$api.capitalApi.payPalAbnormalBillList(returnDatas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.confirmedList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.confirmedList();
    },
  },
};
</script>
<style lang="scss" scoped>
.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.search {
  margin: 24px 0;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    display: flex;
    justify-content: center;
    align-items: center;

    > * {
      margin-bottom: 26px;
    }
  }
}

.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-right: 5px;
    word-break: break-all;
    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    height: 100px;

    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.keHu {
  p {
    text-align: center;
  }
}

.xianShiLXXX {
  padding: 16px;

  p {
    font-size: 14px;
    line-height: 20px;
    padding: 5px;
    display: flex;
    align-items: center;
  }

  /deep/.el-image,
  .payImg {
    $imgSize: 80px;
    width: $imgSize;
    height: $imgSize;
    transition: 0.3s;
    text-align: center;

    i {
      font-size: $imgSize/4;
      line-height: $imgSize;
    }
  }
}

.lookMore {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
</style>
